import React from "react";
import { db } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";

import Input from "../../Components/forms/Input";

import styles from "./WebPushRegister.module.css";
import Loading from "../../Components/Loading";

import { formatDate } from "../../utils/standaloneUtils";

const WebPushAgendamentos = () => {
  const [data, setData] = React.useState([]);
  const [userSearched, setUserSearched] = React.useState("");
  const [loading, setloading] = React.useState(true);
  var objData = [];

  React.useEffect(() => {
    async function getRegister() {
      try {
        setloading(false);
        const queryPermission = collection(db, "agendamentos-web-push");
        const docs = await getDocs(queryPermission);
        objData = [];
        docs.forEach((doc) => {
          objData.push(doc.data());
          objData.id = doc.id;

          if (data.length === 0) {
            setData((prevData) => [...prevData, objData]);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        setloading(true);
      }
    }
    getRegister();
  }, []);
  function handleActiveDetails() {
    setActiveDetails(!activeDetails);
  }
  function handleSearchUser({ target }) {
    setUserSearched(target.value);
  }

  if (!loading) {
    return <Loading>Carregando os Registros...</Loading>;
  }
  return (
    <section>
      <div className="container">
        <h1>Notificações Agendadas</h1>
        <Input
          placeholder={"Procure por Titulo"}
          onChange={handleSearchUser}
          value={userSearched}
        />
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Data agendamento</th>
              <th>Titulo</th>
              <th>Publico</th>
              <th>Data Agendada</th>
              <th>Descrição</th>
              <th>Status</th>
            </tr>
          </thead>
          {objData.map((register) => (
            <tbody key={register.id}>
              <tr onClick={handleActiveDetails}>
                <td>
                  {moment(register.dateSend).format("MMMM Do YYYY, h:mm:ss a")}
                </td>
                <td>{register.title}</td>
                <td>{register.audience}</td>
                <td>{`${formatDate(register.dateSchedule)}`}</td>
                <td>{register.body}</td>
                <td>{register.status}</td>
              </tr>
            </tbody>
          ))}
        </table>
      </div>
    </section>
  );
};

export default WebPushAgendamentos;
